module.exports = __webpack_public_path__ + "static/media/seconds.07e0ab79.png";